import { AiFillAppstore } from "react-icons/ai";
import { FaFileExcel, FaGlobe, FaUsers} from "react-icons/fa";
import { SiProgress} from "react-icons/si";

// Features Data
export const featuresData = [
  {
    id: 1,
    title: "Web Automation",
    des: "I automate e-commerce, marketing, and data tasks using Python, Selenium, JS & Sheets, creating efficient solutions that save time & boost productivity.",
  },
  {
    id: 2,
    icon: <AiFillAppstore />,
    title: "Web Development",
    des: "I develop dynamic, user-friendly websites with WordPress, Shopify, React & JavaScript, ensuring high performance, scalability, and great UX.",
  },
  {
    id: 3,
    icon: <SiProgress />,
    title: "SEO Optimisation",
    des: "I optimize websites for SEO using keyword research, technical SEO, and performance tuning to boost rankings, drive traffic, and increase conversions.",
  },
  {
    id: 4,
    icon: <FaFileExcel />,
    title: "Advanced Excel",
    des: "I specialize in Advanced Excel, using formulas, macros, and automation to analyze data, generate reports, and optimize business workflows efficiently.",
  },
  {
    id: 5,
    icon: <FaUsers />,
    title: "Digital Marketing",
    des: "I specialize in Whatsapp marketing, Facebook & Google Ads, creating targeted campaigns, optimizing conversions, and automating strategies for growth.",
  },
  {
    id: 6,
    icon: <FaGlobe />,
    title: "Hosting Websites",
    des: "I set up and manage website hosting, ensuring fast, secure, and reliable performance for WordPress, Shopify, and custom web applications.",
  },
];
